module.exports = __webpack_public_path__ + "img/C08TechVanisWisdom_ua.f128a5ee.webp";